import React from 'react';
import StyledMenuItem from 'views/rebranded-module/common/components/Logical/LayoutV2/NavBar/NavMenuItem/NavMenuItem.styles';
import { ListItemIcon } from '@mui/material';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import Typography500 from 'views/common/components/UI/Typography500';

const NavMenuItem = (props) => {
  const {
    item,
    onClick,
    preventAnimation,
    className,
    readOnly = false,
  } = props;

  return (
    <StyledMenuItem
      component={NavigatorLink}
      href={item.path}
      onClick={onClick}
      {...(item.testId ? { 'data-testid': item.testId } : {})}
      className={`${className} 
      ${preventAnimation ? 'NMIpreventAnimation' : ''}
      ${readOnly ? 'NMIReadOnly' : ''}
      ${item.subLable ? 'NMIHasSubLable' : ''}`}
      disableRipple={preventAnimation}>
      <ListItemIcon className="NMIIcon">{item.icon}</ListItemIcon>
      <Typography500
        className={`${item.userName ? 'NMIUserName' : ''} NMILable`}
        variant="body2">
        {item.label}
        {item.subLable && (
          <Typography500 className="NMISubLable" variant="body2">
            {item.subLable}
          </Typography500>
        )}
      </Typography500>
    </StyledMenuItem>
  );
};

export { NavMenuItem };
